export default __webpack_public_path__ + "img/logo-redirect.56dcf536.svg";